import { CurrencyService } from '@acme/api';
import { CurrencyFilter } from '@acme/domains';
import { CurrencyList } from '@acme/features';
import { Breadcrumb, BreadcrumbItem } from '@acme/foundation';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const CurrencyListPage = () => {
  const navigate = useNavigate();
  const currencyLoader = useCallback(async (filter: CurrencyFilter) => {
    const response = await CurrencyService.getApiV1Currency(filter);
    return response.data;
  }, []);

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: 'Курсы валют',
      onClick: () => navigate('/rates'),
    },
    {
      label: 'Справочник валют',
    },
  ];
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <Breadcrumb items={breadcrumbItems} />
        <CurrencyList loader={currencyLoader} />
      </div>
    </div>
  );
};
